import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import swal from "sweetalert";
import axios from "axios";
import Button from "@material-ui/core/Button";
import "../../modal.css";
import { api_path } from "../../shared";
function AddRejectModal(props) {
  const [REMARK, SET_REMARK] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isRejectButtonDisabled, setRejectButtonDisabled] = useState(true);
  const [getOrderStatus, setOrderStatus] = useState([]);
  const [orderStatusList, setOrderStatusList] = useState([]);
  const [selectOrderStatus, setSelectOrderStatus] = useState([]);
  const REJECT_ALLOWED_STATUS = ["1","3","4","5","6","7","8","9"];

useEffect(() => {
  setRejectButtonDisabled(!REJECT_ALLOWED_STATUS.includes(props.STATUS));
}, [props.STATUS]);
  useEffect(() => {
    fetchOrderStatus();
  }, []);
  const fetchOrderStatus = () => {
    axios
      .get(api_path + `/MS_INQUIRY_MASTER.php?type=REJECT_CS`)
      .then((response) => {
        setOrderStatusList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleOrderStatusChange = (obj) => {
    setSelectOrderStatus(obj.INQUIRY_MASTER_VALUE);
    setOrderStatus({
      INQUIRY_MASTER_VALUE: obj.INQUIRY_MASTER_VALUE,
      INQUIRY_MASTER_EN: obj.INQUIRY_MASTER_EN,
    });
  };
  function updateOrderStatus(ORDER_ID, REMARK, USER_ID) {
    var data = {
      ORDER_ID: ORDER_ID,
      ORDER_STATUS: 3,
      REMARK: REMARK,
      REASON_ID: selectOrderStatus,
      REASON_NAME: getOrderStatus.INQUIRY_MASTER_EN,
      USER_ID: USER_ID,
    };
    fetch(api_path + "/TS_SALES_ORDER_UPDATE_STATUS.php", {
      method: "POST",
      headers: {
        Accept: "application/form-data",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result["status"] == "200") {
          swal("Done.", "Save data successfully.", "success", {
            buttons: true,
            timer: 5000,
          }).then(function () {
            const url =
              api_path +
              "/SENDMAIL_SALESORDER.php?order_id=" +
              ORDER_ID +
              "&flag=reject&order_status=3";
            axios
              .get(url)
              .then((response) => {
                // handle success
                console.log(result["message"]);
              })
              .then((data) => {
                console.log(data);
                // Handle data
              })
              .catch((error) => {
                // handle errors
              });
            window.location = "./SalesOrderDetail?order_id=" + ORDER_ID + "";
            ////////////////////////////////////////////////////
          });
        } else {
          swal("Sorry", result["message"], "error", {
            buttons: true,
            timer: 1000,
          });
        }
      });
  }
  return (
    <>
      <Button
        disabled={props.disabled} 
        type="button"
        fullWidth
        variant="contained"
        color="secondary"
        onClick={handleShow}
      >
Reject
      </Button>

      <Modal
        className="modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Reject</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={(e) => {
              handleClose();
              e.preventDefault();
              updateOrderStatus(props.ORDER_ID, REMARK, props.USER_ID);
            }}
            id="editmodal"
            className=""
          >
            <input type="hidden" value={props.ORDER_ID} />

        
            <label>
                    REJECT REASON:
                    <Select
                      styles={{
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                      }}
                      placeholder="Select..."
                      value={getOrderStatus}
                      options={orderStatusList}
                      onChange={handleOrderStatusChange}
                      getOptionLabel={(x) => x.INQUIRY_MASTER_EN}
                      getOptionValue={(x) => x.INQUIRY_MASTER_VALUE}
                      required
                    />
                  </label>
                  <label>
              Remark:
              </label>
              <textarea id="txtArea" rows="3" cols="50"
              value={REMARK}
              onChange={(e) => SET_REMARK(e.target.value)}
              inputProps = {{maxLength:250}}
              ></textarea>
         
            
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleClose}>
            Close
          </button>
          <button className="btn btn-primary" form="editmodal">
            Reject
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddRejectModal;
